export const uploadButtonData = [
  {
    maxResolution: { width: 1920, height: 1080 },
    maxFileSize: 5,
    text: "COVER",
  },
  {
    maxResolution: { width: 1024, height: 1024 },
    maxFileSize: 2,
    text: "ICON",
  },
  {
    maxResolution: { width: 2048, height: 2048 },
    maxFileSize: 5,
    enableVideo: true,
    text: "NFT",
  },
];
